import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import axios from "axios";
import { baseurl, imageUrl } from "../Baseurl";
import { Link } from "react-router-dom";

// Custom Arrow Button
const ArrowButton = ({ className, style, onClick, icon }) => {
  return (
    <button
      className={className}
      style={{
        ...style,
        display: "block",
        background: "transparent",
        border: "none",
        color: "#fff",
        backgroundColor: "#0000008a",
      }}
      onClick={onClick}
    >
      {icon}
    </button>
  );
};

export default function BestSellingProduct() {
  const [listings, setListings] = useState([]);
  const [loading, setLoading] = useState(true);

  const selectedCurrency = sessionStorage.getItem("selectedCurrency") || "INR";
  const dollarRate = parseFloat(localStorage.getItem("dollarRate")) || 1;

  const convertPrice = (inrPrice) => {
    if (!inrPrice || isNaN(inrPrice)) return "N/A";
    return selectedCurrency === "USD"
      ? `$${(inrPrice / dollarRate).toFixed(2)}`
      : `₹${inrPrice}`;
  };

  const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".webp"];
  const findFirstImage = (images) =>
    Array.isArray(images)
      ? images.find((img) =>
          imageExtensions.some((ext) => img.toLowerCase().endsWith(ext))
        )
      : null;

  useEffect(() => {
    const fetchListings = async () => {
      try {
        const res = await axios.get(`${baseurl}getHomePageListings`);
        const data = res.data?.listings || [];

        const filtered = data
          .filter((item) => item.sale_type === "Best Selling")
          .sort((a, b) =>
            b.created_at && a.created_at
              ? new Date(b.created_at) - new Date(a.created_at)
              : b.listing_id - a.listing_id
          )
          .slice(0, 8);

        setListings(filtered);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching listings:", error);
        setLoading(false);
      }
    };

    fetchListings();
  }, []);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    autoplay: true,
    arrows: true,
    prevArrow: <ArrowButton className="slick-prev" icon="❮" />,
    nextArrow: <ArrowButton className="slick-next" icon="❯" />,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 4 } },
      { breakpoint: 768, settings: { slidesToShow: 2 } },
      { breakpoint: 480, settings: { slidesToShow: 2 } },
    ],
  };

  return (
    <div className="container py-4">
      <h2 className="mb-3 fw-bold">Best Selling Products</h2>
      <Slider {...settings}>
        {loading
          ? [...Array(5)].map((_, idx) => (
              <div
                key={idx}
                className="product-slide p-1"
                style={{ padding: "0 10px" }}
              >
                <div className="card product-card h-100">
                  <div
                    style={{
                      height: "180px",
                      background: "#e0e0e0",
                      borderRadius: "4px",
                      animation: "pulse 1.5s infinite",
                      marginBottom: "10px",
                    }}
                  ></div>
                  <div style={{ padding: "0 10px" }}>
                    <div
                      style={{
                        height: "20px",
                        background: "#e0e0e0",
                        marginBottom: "5px",
                        animation: "pulse 1.5s infinite",
                      }}
                    ></div>
                    <div
                      style={{
                        height: "20px",
                        width: "50%",
                        background: "#e0e0e0",
                        marginBottom: "5px",
                        animation: "pulse 1.5s infinite",
                      }}
                    ></div>
                    <div
                      style={{
                        height: "30px",
                        background: "#e0e0e0",
                        animation: "pulse 1.5s infinite",
                        borderRadius: "4px",
                      }}
                    ></div>
                  </div>
                </div>
              </div>
            ))
          : listings.map((listing, idx) => {
              const imageToDisplay =
                findFirstImage(listing.images || []) || "default-image.jpg";

              return (
                <div
                  key={idx}
                  className="product-slide p-1"
                  style={{ padding: "0 10px" }}
                >
                  <div className="card product-card h-100">
                    <img
                      src={`${imageUrl}listing/${imageToDisplay}`}
                      className="card-img-top"
                      alt={listing.title}
                      style={{ height: "180px", objectFit: "cover" }}
                    />
                    <div className="card-body">
                      <h3 className="card-title">{listing.title}</h3>
                      <div className="featured-rating">★★★★★</div>
                      <p className="card-text text-success fw-bold">
                        {convertPrice(listing.price)}
                      </p>
                      <Link
                        to={`/product/${listing.slug}`}
                        className="btn card-btn w-100"
                      >
                        View Details
                      </Link>
                    </div>
                  </div>
                </div>
              );
            })}
      </Slider>

      {/* Skeleton animation */}
      <style>{`
        @keyframes pulse {
          0% { opacity: 0.3; }
          50% { opacity: 0.7; }
          100% { opacity: 0.3; }
        }
      `}</style>
    </div>
  );
}
